module.exports = __webpack_public_path__ + "static/img/toast.92c8f15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/toast.jpg
// module id = qN+3
// module chunks = 35